import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import localeTh from '@angular/common/locales/th';
//import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
registerLocaleData(localeTh);

import { ApixuService } from "../app/core/services/apixu.service";
import { ExcelService } from '../app/services/excel.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SupporterComponent } from './supporter/supporter.component';
import { HeaderComponent } from './supporter/header/header.component';
import { FooterComponent } from './supporter/footer/footer.component';
import { SidebarComponent } from './supporter/sidebar/sidebar.component';
import { ActionComponent } from './core/component/action/action.component';
import { KpiallComponent } from './core/component/kpiall/kpiall.component';
import { MyprofileComponent } from './core/component/myprofile/myprofile.component';
import { FindlanddataComponent } from './core/component/findlanddata/findlanddata.component';
import { AcceptComponent } from './core/component/accept/accept.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { NgxGaugeModule } from 'ngx-gauge';
// import { NgxChartsModule } from '@swimlane/ngx-charts/release/ngx-charts.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
// import { NgxChartModule } from 'ngx-chart/lib/ngx-chart.module';
// import { NgxChartModule } from 'ngx-chart';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule} from '@angular/material/dialog';

import { environment } from '../environments/environment';
import { AgmCoreModule } from '@agm/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFirestoreModule } from '@angular/fire/firestore';

import { RepairgroupComponent } from './core/component/repairgroup/repairgroup.component';
import { StockonlineComponent } from './core/component/stockonline/stockonline.component';
import { TestComponent } from './core/component/test/test.component';
import { PlantactionComponent } from './core/component/plantaction/plantaction.component';
import { PrbrdComponent } from './core/component/prbrd/prbrd.component';
import { GroupcutComponent } from './core/component/groupcut/groupcut.component';

import { DataTablesModule } from 'angular-datatables';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatTreeModule } from '@angular/material/tree';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ChartModule } from 'angular2-chartjs';
import { CreditComponent } from './core/component/credit/credit.component';
import { ManageareaComponent } from './core/component/managearea/managearea.component';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { DocforgroupcutComponent } from './core/component/docforgroupcut/docforgroupcut.component';
import { ReportplantcutComponent } from './core/component/reportplantcut/reportplantcut.component';
import { RaindropComponent } from './core/component/raindrop/raindrop.component';
import { DocforcreditComponent } from './core/component/docforcredit/docforcredit.component';
import { AskformoneyComponent } from './core/component/askformoney/askformoney.component';
import { FinanceComponent } from './finance/finance.component';
import { DocforaskformoneyComponent } from './core/component/docforaskformoney/docforaskformoney.component';
import { AskforfertilizerComponent } from './core/component/askforfertilizer/askforfertilizer.component';
import { AskforfactorComponent } from './core/component/askforfactor/askforfactor.component';
import { PrintfertilizerComponent } from './core/component/printfertilizer/printfertilizer.component';
import { DocfertilizerComponent } from './core/component/docfertilizer/docfertilizer.component';
import { PrintaskformoneyComponent } from './core/component/printaskformoney/printaskformoney.component';
import { FarmerreportComponent } from './core/component/farmerreport/farmerreport.component';
import { ListaskformoneyheaderComponent } from './core/component/listaskformoneyheader/listaskformoneyheader.component';
import { ListacceptbyheaderComponent } from './core/component/listacceptbyheader/listacceptbyheader.component';
import { Seasone6465Component } from './core/component/seasone6465/seasone6465.component';
import { Season6465dataComponent } from './core/component/season6465data/season6465data.component';
import { PrintqrtruckComponent } from './core/component/printqrtruck/printqrtruck.component';
import { ListhitoryformoneyComponent } from './core/component/listhitoryformoney/listhitoryformoney.component';
import { CutrunningComponent } from './core/component/cutrunning/cutrunning.component';
import { AskforbarcodeComponent } from './core/component/askforbarcode/askforbarcode.component';
import { EditplantinfoComponent } from './core/component/editplantinfo/editplantinfo.component';
import { EditplantinfoManagerComponent } from './core/component/editplantinfo-manager/editplantinfo-manager.component';
import { CheckqueueonlineComponent } from './core/component/checkqueueonline/checkqueueonline.component';
import { AcceptbarcodeComponent } from './core/component/acceptbarcode/acceptbarcode.component';
import { CanpergroupComponent } from './core/component/canpergroup/canpergroup.component';
import { FindcaneinstoreComponent } from './core/component/findcaneinstore/findcaneinstore.component';
import { BorrowqueueComponent } from './core/component/borrowqueue/borrowqueue.component';
import { CheckqueuezoneComponent } from './core/component/checkqueuezone/checkqueuezone.component';
import { AddcutcanetypeComponent } from './core/component/addcutcanetype/addcutcanetype.component';
import { MatNativeDateModule } from '@angular/material/core';
import { FindfarmerdataComponent } from './core/component/findfarmerdata/findfarmerdata.component';
import { EditplantcaneinComponent } from './core/component/editplantcanein/editplantcanein.component';
import { CanepergroupbycutcarComponent } from './core/component/canepergroupbycutcar/canepergroupbycutcar.component';
import { CaneinperdayComponent } from './core/component/caneinperday/caneinperday.component';
import { QueueandarearComponent } from './core/component/queueandarear/queueandarear.component';
import { SugarcaneperhourComponent } from './core/component/sugarcaneperhour/sugarcaneperhour.component';
import { registerLocaleData } from '@angular/common';
import { CaneperzonebygroupComponent } from './core/component/caneperzonebygroup/caneperzonebygroup.component';
import { PrintbarcodeComponent } from './core/component/printbarcode/printbarcode.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { AskforbanknumberComponent } from './core/component/askforbanknumber/askforbanknumber.component';
import { RainfallComponent } from './core/component/rainfall/rainfall.component';
import { ChartsModule } from 'ng2-charts';
import { ViewsupportterComponent } from './core/component/viewsupportter/viewsupportter.component';
import { DoccheckfarmerComponent } from './core/component/doccheckfarmer/doccheckfarmer.component';
import { ReportbynotifyComponent } from './core/component/reportbynotify/reportbynotify.component';
import { GrouprepairComponent } from './core/component/grouprepair/grouprepair.component';
import { ResulttsupportterComponent } from './core/component/resulttsupportter/resulttsupportter.component';
import { DashboardkpiComponent } from './core/component/dashboardkpi/dashboardkpi.component';
import { BugandgermComponent } from './core/component/bugandgerm/bugandgerm.component';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { DocmeetfarmerComponent } from './core/component/docmeetfarmer/docmeetfarmer.component';
import { EditcaneinplantComponent } from './core/component/editcaneinplant/editcaneinplant.component';
import { EditplotComponent } from './core/component/editplot/editplot.component';
import { AuditListComponent } from './core/component/audit-list/audit-list.component';
import { AdtobPipe } from './adtob.pipe';
import { GetFert3Component } from './core/component/get-fert3/get-fert3.component';
import { EditplotManagerComponent } from './core/component/editplot-manager/editplot-manager.component';
import { ListComponent } from './core/component/editplot-manager/list/list.component';
import { EditplotPartComponent } from './core/component/editplot-part/editplot-part.component';
import { EditplotPartFormComponent } from './core/component/editplot-part-form/editplot-part-form.component';
import { EmployeeComponent } from './core/component/employee/employee.component';
import { DashboardComponent } from './core/component/employee/dashboard/dashboard.component';
import { EmpAddComponent } from './core/component/employee/emp-add/emp-add.component';
import { EmpListComponent } from './core/component/employee/emp-list/emp-list.component';
import { EmpDepComponent } from './core/component/employee/emp-dep/emp-dep.component';
import { EmpTrainComponent } from './core/component/employee/emp-train/emp-train.component';
import { EmpDashboardComponent } from './core/component/employee/emp-dashboard/emp-dashboard.component';
import { EmpPositionComponent } from './core/component/employee/emp-position/emp-position.component';
import { EmpFactionComponent } from './core/component/employee/emp-faction/emp-faction.component';
import { ExecutiveComponent } from './core/component/dashboard/executive/executive.component';
import { CpMapComponent } from './core/component/map/cp-map/cp-map.component';
import { Askforfactor6667Component } from './core/component/askforfactor6667/askforfactor6667.component';
import { Askformoney6667Component } from './core/component/askformoney6667/askformoney6667.component';
import { AnalysisPlanComponent } from './core/component/analysis-plan/analysis-plan.component';
import { DpsListComponent } from './core/component/deposit/dps-list/dps-list.component';
import { DpsEditComponent } from './core/component/deposit/dps-edit/dps-edit.component';
import { DpsDetailComponent } from './core/component/deposit/dps-detail/dps-detail.component';
import { OilpayComponent } from './core/component/oilpay/oilpay.component';
import { PrintdocComponent } from './core/component/oilpay/printdoc/printdoc.component';
import { InforQcardComponent } from './core/component/infor-qcard/infor-qcard.component';
import { CarcutReportComponent } from './core/component/carcut-report/carcut-report.component';
import { ReportDismanAreaLvComponent } from './core/component/report-disman-area-lv/report-disman-area-lv.component';
import { SumDataCutComponent } from './core/component/sum-data-cut/sum-data-cut.component';
import { FarmerDevSysComponent } from './core/component/farmer-dev-sys/farmer-dev-sys.component';
import { FinanceOfdataComponent } from './core/component/finance-ofdata/finance-ofdata.component';
import { FileExcelComponent } from './core/component/file-excel/file-excel.component';
import { MoveOnQComponent } from './core/component/move-on-q/move-on-q.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FinanceListComponent } from './core/component/finance-list/finance-list.component';
import { FarmerAssessmentComponent } from './core/component/farmer-assessment/farmer-assessment.component';
import { ListKpiComponent } from './core/component/list-kpi/list-kpi.component';
import { ListKpiZoneComponent } from './core/component/list-kpi-zone/list-kpi-zone.component';

import { OkayGetFert3Component } from './core/component/okay-get-fert3/okay-get-fert3.component';
import { ForTestComponent } from './core/component/for-test/for-test.component';
import { KmlGeneratorComponent } from './core/component/kml-generator/kml-generator.component';
import { NewsComponent } from './core/component/news/news.component';
import { UpfileComponent } from './core/component/upfile/upfile.component';
import { Askforfactor67Component } from './core/component/askforfactor67/askforfactor67.component';
import { Askformoney67Component } from './core/component/askformoney67/askformoney67.component';
import { Docforaskformoney67Component } from './core/component/docforaskformoney67/docforaskformoney67.component';
import { Listaskformoney67Component } from './core/component/listaskformoney67/listaskformoney67.component';
import { NewInformComponent } from './core/component/new-inform/new-inform.component';
import { CaneYardComponent } from './core/component/cane-yard/cane-yard.component';
import { FileFinanceComponent } from './core/component/file-finance/file-finance.component';
import { DashboardCutFComponent } from './core/component/dashboard/dashboard-cut-f/dashboard-cut-f.component';
import { PrintReportCutFComponent } from './core/component/print-report-cut-f/print-report-cut-f.component';
import { Sidebar2Component } from './supporter/sidebar2/sidebar2.component';
import { NewsEditComponent } from './core/component/news-edit/news-edit.component';
import { DashboardGrowedFComponent } from './core/component/dashboard-growed-f/dashboard-growed-f.component';
import { BrdprojectComponent } from './core/component/brdproject/brdproject.component';
import { ProjectMemberComponent } from './core/component/project-member/project-member.component';
import { CallbackComponent } from './core/callback/callback.component';
import { Askformoney68Component } from './core/component/askformoney68/askformoney68.component';
import { Askforfactor68Component } from './core/component/askforfactor68/askforfactor68.component';
import { Listaskformoney68Component } from './core/component/listaskformoney68/listaskformoney68.component';
import { BrdDiaryCPCComponent } from './core/component/report/brd-diary-cpc/brd-diary-cpc.component';
import { FollowWorkComponent } from './core/component/follow-work/follow-work.component';
import { SugarcaneQualityComponent } from './core/component/sugarcane-quality/sugarcane-quality.component';
import { SupervisDiaryCpcComponent } from './core/component/report/supervis-diary-cpc/supervis-diary-cpc.component';
import { CanequalityComponent } from './core/component/canequality/canequality.component';
import { BrdCpcFormComponent } from './core/component/report/brd-cpc-form/brd-cpc-form.component';
import { SaveFormCanequalityComponent } from './core/component/canequality/save-form-canequality/save-form-canequality.component';
import { PrintFarmersComponent } from './core/component/print-farmers/print-farmers.component';
import { EditGetfactorComponent } from './core/component/edit-getfactor/edit-getfactor.component';
import { MapGroupcodeComponent } from './core/component/map-groupcode/map-groupcode.component';
//import { initializeKeycloak } from './keyclock/keyclock.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SupporterComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ActionComponent,
    KpiallComponent,
    MyprofileComponent,
    FindlanddataComponent,
    AcceptComponent,
    RepairgroupComponent,
    StockonlineComponent,
    TestComponent,
    PlantactionComponent,
    PrbrdComponent,
    GroupcutComponent,
    CreditComponent,
    ManageareaComponent,
    DocforgroupcutComponent,
    ReportplantcutComponent,
    RaindropComponent,
    DocforcreditComponent,
    AskformoneyComponent,
    FinanceComponent,
    DocforaskformoneyComponent,
    AskforfertilizerComponent,
    AskforfactorComponent,
    PrintfertilizerComponent,
    DocfertilizerComponent,
    PrintaskformoneyComponent,
    FarmerreportComponent,
    ListaskformoneyheaderComponent,
    ListacceptbyheaderComponent,
    Seasone6465Component,
    Season6465dataComponent,
    PrintqrtruckComponent,
    ListhitoryformoneyComponent,
    CutrunningComponent,
    AskforbarcodeComponent,
    EditplantinfoComponent,
    EditplantinfoManagerComponent,
    CheckqueueonlineComponent,
    AcceptbarcodeComponent,
    CanpergroupComponent,
    FindcaneinstoreComponent,
    BorrowqueueComponent,
    CheckqueuezoneComponent,
    AddcutcanetypeComponent,
    FindfarmerdataComponent,
    EditplantcaneinComponent,
    CanepergroupbycutcarComponent,
    CaneinperdayComponent,
    QueueandarearComponent,
    SugarcaneperhourComponent,
    CaneperzonebygroupComponent,
    PrintbarcodeComponent,
    AskforbanknumberComponent,
    RainfallComponent,
    ViewsupportterComponent,
    DoccheckfarmerComponent,
    ReportbynotifyComponent,
    GrouprepairComponent,
    ResulttsupportterComponent,
    DashboardkpiComponent,
    BugandgermComponent,
    DocmeetfarmerComponent,
    EditcaneinplantComponent,
    EditplotComponent,
    AuditListComponent,
    AdtobPipe,
    GetFert3Component,
    EditplotManagerComponent,
    ListComponent,
    EditplotPartComponent,
    EditplotPartFormComponent,
    EmployeeComponent,
    DashboardComponent,
    EmpAddComponent,
    EmpListComponent,
    EmpDepComponent,
    EmpTrainComponent,
    EmpDashboardComponent,
    EmpPositionComponent,
    EmpFactionComponent,
    ExecutiveComponent,
    CpMapComponent,
    Askforfactor6667Component,
    Askformoney6667Component,
    AnalysisPlanComponent,
    DpsListComponent,
    DpsEditComponent,
    DpsDetailComponent,
    OilpayComponent,
    PrintdocComponent,
    InforQcardComponent,
    CarcutReportComponent,
    ReportDismanAreaLvComponent,
    SumDataCutComponent,
    FarmerDevSysComponent,
    FinanceOfdataComponent,
    FileExcelComponent,
    MoveOnQComponent,
    FinanceListComponent,
    FarmerAssessmentComponent,
    ListKpiComponent,
    OkayGetFert3Component,
    ForTestComponent,
    KmlGeneratorComponent,
    NewsComponent,
    UpfileComponent,
    Askforfactor67Component,
    Askformoney67Component,
    Docforaskformoney67Component,
    Listaskformoney67Component,
    NewInformComponent,
    CaneYardComponent,
    FileFinanceComponent,
    DashboardCutFComponent,
    PrintReportCutFComponent,
    Sidebar2Component,
    ListKpiZoneComponent,
    NewsEditComponent,
    DashboardGrowedFComponent,
    BrdprojectComponent,
    ProjectMemberComponent,
    CallbackComponent,
    Askformoney68Component,
    Askforfactor68Component,
    Listaskformoney68Component,
    BrdDiaryCPCComponent,
    FollowWorkComponent,
    SugarcaneQualityComponent,
    SupervisDiaryCpcComponent,
    CanequalityComponent,
    BrdCpcFormComponent,
    SaveFormCanequalityComponent,
    PrintFarmersComponent,
    EditGetfactorComponent,
    MapGroupcodeComponent,

  ],
  imports: [
    BrowserModule,
    Ng2SearchPipeModule,
    FormsModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    NgxBarcodeModule,
    MatCheckboxModule,
    NgxChartsModule,
    // NgxChartModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatSidenavModule,
    NgxSpinnerModule,
    MatSelectModule,
    MatToolbarModule,
    MatListModule,
    MatSlideToggleModule,
    //NgxMatSelectSearchModule,
    RouterModule,
    MatRadioModule,
    HttpClientModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatSortModule,
    MatTableModule,
    MatTreeModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatCardModule,
    MatMenuModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTabsModule,
    MatDialogModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAf9YahEjgiXdjEHY5q-MDJ-wsxAplvUMY',
      libraries: ['places', 'drawing', 'geometry'],
    }),
    DataTablesModule,
    ChartModule,
    ChartsModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') })
    //, KeycloakAngularModule
  ],
  exports: [MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, AngularFirestoreModule, MatBadgeModule,],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: "th-TH",
    },
    ApixuService,
    ExcelService

  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
